import Vue from 'vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

Vue.use(Loading);

const Loader = {
  data() {
    return {
      isLoading: null,
    };
  },
  methods: {
    ShowWait(parentcomponent) {
      let self = this;
      self.isLoading = self.$loading.show({
        container: parentcomponent,
        canCancel: false,
        onCancel: self.onCancel,
        loader: 'bars',
        color: '#41b883',
        backgroundColor: '#ffffff',
        width: 90,
        height: 90,
        zIndex: 9999,
      });
    },
    HideWait() {
      let self = this;
      if (self.isLoading !== null) {
        self.isLoading.hide();
      }
    },
  },
};

export default Loader;
